<template>
  <div class="option-service-remark">
    <el-input v-if="canEdit" v-model="detail[field]" type="textarea" :disabled="saving" :autosize="autosize"
      @change="saveRemark"></el-input>
    <span v-else>{{ detail[field] }}</span>
  </div>
</template>

<script>
const PERMISSION_MAP = {
  leader_remark: 746,
  mechanic_remark: 747
}

export default {
  name: 'OptionServiceRemark',
  props: {
    detail: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: true,
      validator: value => Object.prototype.hasOwnProperty.call(PERMISSION_MAP, value)
    }
  },
  data() {
    return {
      saving: false,
      autosize: { minRows: 2, maxRows: 4 }
    }
  },
  computed: {
    // 两类备注分别使用独立权限，未授权时仅展示文本。
    canEdit() {
      return this.isAuth(PERMISSION_MAP[this.field])
    }
  },
  methods: {
    /**
     * 备注内容发生变化时保存当前服务单明细，空字符串用于清空备注。
     * @param {String} remark 当前备注内容
     */
    saveRemark(remark) {
      if (this.saving) return
      this.saving = true
      this.$api.optionServiceApi.updateDetailRemark({
        id: this.detail.id,
        field: this.field,
        remark
      }).then(res => {
        this.$message.success(res.msg || this.$t('message.saveSuccess'))
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.option-service-remark {
  width: 100%;

  /deep/ .el-textarea__inner {
    padding: 5px;
    line-height: 18px;
    height: 100px !important;
  }
}
</style>
